import { TIENDA } from "../data/config";
import Reveal from "./ui/Reveal";

const VALORES = [
  {
    titulo: "Transparencia total",
    texto: "Un solo ingrediente en la etiqueta. Sabes exactamente lo que comes.",
  },
  {
    titulo: "Calidad artesanal",
    texto: "Lotes pequeños, cuidados uno a uno, sin producción en masa.",
  },
  {
    titulo: "Cercanía",
    texto: `Somos de ${TIENDA.ciudad} y atendemos a cada cliente de forma personal.`,
  },
];

const NosotrosPropuesta = () => {
  return (
    <section id="nosotros" className="bg-cream py-20 md:py-section">
      <div className="mx-auto max-w-container px-5 md:px-16">
        {/*
          Orden en móvil (order-*):  1=badge+título  2=imagen  3=descripción+valores
          Orden en desktop (lg:grid-cols-2): columna izq agrupa 1+3, columna der la imagen
          con lg:row-span-2 para ocupar ambas filas.
        */}
        <div className="grid items-center gap-10 md:gap-12 lg:grid-cols-2 lg:gap-16">

          {/* 1 — Badge + título */}
          <Reveal className="order-1">
            <span className="text-xs font-semibold uppercase tracking-label text-secondary">
              Nuestro propósito
            </span>
            <h2 className="mt-3 font-literata text-2xl font-bold text-charcoal sm:text-3xl md:text-4xl">
              Maní natural, hecho con propósito
            </h2>
          </Reveal>

          {/* 2 — Imagen: order-2 en móvil, columna derecha con row-span en desktop */}
          <Reveal delay={120} className="order-2 overflow-hidden rounded-xl border border-peanut/40 shadow-card lg:row-span-2 lg:order-none">
            <img
              src="https://images.pexels.com/photos/6823293/pexels-photo-6823293.jpeg?auto=compress&cs=tinysrgb&w=1000"
              alt="Pan con mantequilla de maní y frutos secos sobre mesa de madera"
              className="aspect-[4/5] w-full object-cover"
              loading="lazy"
            />
          </Reveal>

          {/* 3 — Descripción + valores: order-3 en móvil, segunda fila col-izq en desktop */}
          <Reveal className="order-3">
            <p className="text-lg text-ink-variant">
              {TIENDA.nombre} nació en {TIENDA.ciudad} con una idea simple: que
              comer rico y comer sano puedan ir de la mano. Nos cansamos de leer
              etiquetas llenas de ingredientes imposibles de pronunciar, así que
              decidimos hacer la mantequilla de maní como debería ser: con maní y
              nada más.
            </p>
            <p className="mt-4 text-lg text-ink-variant">
              Lo que nos caracteriza es la obsesión por lo natural. Cada frasco es
              una promesa de que estás llevando a casa un producto honesto, sin
              atajos y hecho con cariño.
            </p>

            <ul className="mt-10 space-y-6 px-8 sm:px-0">
              {VALORES.map((valor) => (
                <li key={valor.titulo} className="flex gap-4">
                  <span className="mt-1 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-forest text-sm font-bold text-white" aria-hidden="true">
                    ✓
                  </span>
                  <div>
                    <h3 className="font-literata text-lg font-semibold text-charcoal">
                      {valor.titulo}
                    </h3>
                    <p className="mt-1 text-base text-ink-variant">{valor.texto}</p>
                  </div>
                </li>
              ))}
            </ul>
          </Reveal>

        </div>
      </div>
    </section>
  );
};

export default NosotrosPropuesta;
